import React from "react";
import DataSelector from "./DataSelector"
import FilterSelector from "./FilterSelector"
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import SearchIcon from '@mui/icons-material/Search'
import GPAP_Button from '../../../../../gpap-lib/Button_Collection'


const FilterCriteria = (props) => {

    return(
        <Grid container justify="right" spacing={1}>
            <Grid item >
                <DataSelector
                    title="Start Date"
                    selectsStart={true}
                    selectsEnd={false}
                    selected={props.startDate}
                    startDate={props.startDate}
                    endDate={props.endDate}
                    onChange={props.handleStartDate}
            />
            </Grid>
            <Grid item >
                <DataSelector
                    title="End Date"
                    selectsStart={false}
                    selectsEnd={true}
                    selected={props.endDate}
                    startDate={props.startDate}
                    endDate={props.endDate}
                    onChange={props.handleEndDate}
                />
            </Grid>
            <Grid item >
                <FilterSelector
                    title={props.libraryStrategy.title}
                    name="libraryStrategy"
                    value={props.libraryStrategy.value}
                    changeSelection={props.changeSelection}
                    selection={props.libraryStrategy.selection}
                />
            </Grid>
            <Grid item >
                <FilterSelector
                    title={props.project.title}
                    name="project"
                    value={props.project.value}
                    changeSelection={props.changeSelection}
                    selection={props.project.selection}
                />
            </Grid>
            <Grid item >
                <FilterSelector
                    title={props.group.title}
                    name="group"
                    value={props.group.value}
                    changeSelection={props.changeSelection}
                    selection={props.group.selection}
                />
            </Grid>
            <Grid item >
                <FilterSelector
                    title={props.status.title}
                    name="status"
                    value={props.status.value}
                    changeSelection={props.changeSelection}
                    selection={props.status.selection}
                />
            </Grid>
            <Grid item >
                <Typography variant={"h6"}> Search </Typography>
                <GPAP_Button id="submit" startIcon={<SearchIcon />}  onClick={props.filter}>
                    FILTER
                </GPAP_Button>
            </Grid>
        </Grid>
    );
}

export default FilterCriteria;